module.exports = __webpack_public_path__ + "img/Alkhalil.0e99dcc8.png";